import { firebaseAuth } from '../config/firebase'
import { REQUEST_OPTIONS } from '../signup/signup-flow/SignupFlow'
import { track } from './analytics'

const GET_SOCIAL_JWT_URL = 'https://getsocial-jwt-77wxsfu2sa-uc.a.run.app'

declare global {
  var GetSocialSDK: any
}

/**
 * Calls our cloud function to get a JWT based on the user's firebase UID
 * to pass into the GetSocial SDK for auth.
 */
const getGetSocialJWT = async (): Promise<string> => {
  const idToken = await firebaseAuth.currentUser.getIdToken()
  const headers = {
    ...REQUEST_OPTIONS.headers,
    Authorization: `Bearer ${idToken}`,
  }

  try {
    const response = await fetch(GET_SOCIAL_JWT_URL, {
      ...REQUEST_OPTIONS,
      headers,
    })
    const { jwt } = await response.json()
    return jwt
  } catch (err) {
    console.error(err)
    throw err
  }
}

/**
 * Authenticates the current firebase user via GetSocial as a trusted identity.
 * Sets up any referrer info with GetSocial.
 */
export const getSocialAuth = async (): Promise<void> => {
  try {
    const jwt = await getGetSocialJWT()
    const params = {
      identity_type: 'firestore',
      token: jwt,
    }
    const authResponse = await GetSocialSDK.Auth.authenticate(params)
    track('GetSocialIdentityAuth', 'Successful GetSocial identity auth')

    // This field will be populated if the user came from a referral link. If
    // so, set the referrer appropriately via the GetSocial SDK.
    const referrerUserId = authResponse.referral?.referrerUserId
    if (referrerUserId) {
      const wasSuccessful = await GetSocialSDK.Invites.setReferrer(
        GetSocialSDK.UserId.create(referrerUserId),
        'referral',
        {}
      )

      if (wasSuccessful) {
        track('SuccessfulReferralInvite', 'Successful referral invite')
      } else {
        track('UnsuccessfulReferralInvite', 'Unsuccessful referral invite')
      }
    }
  } catch (err) {
    console.error(err)
  }
}
